const FeatureSection = (props) => {
  return (
    <>
      <section className="section-sp1 service-wraper2">
        <div className="container">
          <div className="row">
            <div className="col-xl-3 col-sm-6 mb-30">
              <div className="feature-container feature-bx3">
                <h2 className="counter text-secondary">10</h2>
                <h5 className="ttr-title">Años a tu servicio</h5>
                <div style={{ height: 80 }}>
                  <p>A lo largo del tiempo hemos mantenido nuestros estandares de calidad.</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 mb-30">
              <div className="feature-container feature-bx3">
                <h2 className="counter text-secondary">2</h2>
                <h5 className="ttr-title">Sucursales</h5>
                <div style={{ height: 80 }}>
                  <p>Nos extendemos para llegar a más lugares del país.</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 mb-30">
              <div className="feature-container feature-bx3">
                <h2 className="counter text-secondary">4</h2>
                <h5 className="ttr-title">Profesionales</h5>
                <div style={{ height: 80 }}>
                  <p>Tenemos profesionales formados con la mejor calidad para cuidar de tu salud.</p>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 mb-30">
              <div className="feature-container feature-bx3">
                <h2 className="counter text-secondary">+100</h2>
                <h5 className="ttr-title" style={{fontSize: 18}}>Clientes Satisfechos</h5>
                <div style={{ height: 80 }}>
                  <p>La satisfacción de nuestos clientes habla por nuestro trabajo.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default FeatureSection;
